var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNuevoIngreso(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 41 41",
    fill: "none",
    className: "seg-icon",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.86 35.23h-6.15a.781.781 0 0 1 0-1.56h6.15a.781.781 0 0 1 0 1.56z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.79 38.3c-.43 0-.78-.35-.78-.78v-6.15a.781.781 0 0 1 1.56 0v6.15c0 .43-.35.78-.78.78z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.79 42.57c-4.46 0-8.08-3.64-8.08-8.12s3.63-8.12 8.08-8.12 8.09 3.64 8.09 8.12-3.63 8.12-8.09 8.12zm0-14.69c-3.6 0-6.53 2.95-6.53 6.57s2.93 6.57 6.53 6.57 6.54-2.95 6.54-6.57-2.93-6.57-6.54-6.57zM1 42H.99C.44 42 0 41.54 0 40.99c.06-4.05 1.77-7.53 4.94-10.06 4.35-3.47 11.25-4.84 17.57-3.5.54.12.88.65.77 1.19-.12.54-.65.88-1.19.77-5.76-1.22-12 0-15.9 3.11C3.5 34.64 2.05 37.59 2 41.03c0 .55-.45.99-1 .99zM17.5 23.55c-6.71 0-12.16-5.28-12.16-11.78S10.79 0 17.5 0s12.16 5.28 12.16 11.78S24.2 23.56 17.5 23.56zM17.5 2C11.9 2 7.34 6.38 7.34 11.78s4.56 9.78 10.16 9.78 10.16-4.39 10.16-9.78S23.1 2 17.5 2z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuevoIngreso);
export default __webpack_public_path__ + "static/media/NuevoIngreso.70acca8f.svg";
export { ForwardRef as ReactComponent };